import React, { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";
import API_URL from "../config";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userFromStorage = localStorage.getItem("user");
    if (userFromStorage) {
      setUser(JSON.parse(userFromStorage));
    }
  }, []);

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${API_URL}/api/admin/login`, {
        email_id: email.toLowerCase().trim(),
        password: password,
      });

      if (response.data && response.data.status === "success") {
        const { token } = response.data;
        
        // Decode token payload using standard base64 decoding
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        );
        const payload = JSON.parse(jsonPayload);

        const userData = {
          email: payload.email_id || email,
          role: payload.role || "admin",
          token: token,
        };

        setUser(userData);
        localStorage.setItem("user", JSON.stringify(userData));
        return userData;
      } else {
        throw new Error(response.data?.message || "Invalid credentials");
      }
    } catch (error) {
      console.error("Authentication Context Error:", error);
      throw new Error(
        error.response?.data?.message || error.message || "Failed to log in"
      );
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  const isLoggedIn = () => {
    return !!localStorage.getItem("user");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isLoggedIn }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
